import $ from 'jquery';
import { MQ } from '../tools/MQ';

// https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Multi-touch_interaction

export const init = () => {
	const assistant = document.querySelector('.js-assistant-3d');
	if (assistant == null) return;

	const assistantDraggableItem = assistant.querySelector('.assistant-3d__draggable');
	const assistantOverlay = assistant.querySelector('.assistant-3d__overlay');
	const assistantTooltips = assistant.querySelectorAll('.assistant-3d__tooltip');
	const toggledTableItems = assistant.nextElementSibling ? assistant.nextElementSibling.querySelectorAll('h4') : [];
	const mobileBgOffset = 'mobileBgOffset' in assistant.dataset ? parseInt(assistant.dataset.mobileBgOffset) : 0; // bg offset 0 - 100% from right on small screen

	const viewportWidth = assistant.clientWidth;
	const viewportHeight = assistant.clientHeight;
	const assistantWidth = assistantDraggableItem.clientWidth;
	const assistantHeight = assistantDraggableItem.clientHeight;

	// Position cache
	let topCache = 0;
	let leftCache = 0;
	let newTop;
	let newLeft;

	// Cache variables
	let touchCache = new Array();
	let moveCache = null;

	function isTouchDevice() {
		return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
	}

	//touch events -----------------------------------------

	function touchSetPosition(ev) {
		if (ev.touches.length == 2 && ev.changedTouches.length == 2) {
			// Check if the two target touches are the same ones that started
			let point1 = -1,
				point2 = -1;
			for (let i = 0; i < touchCache.length; i++) {
				if (touchCache[i].identifier == ev.touches[0].identifier) point1 = i;
				if (touchCache[i].identifier == ev.touches[1].identifier) point2 = i;
			}
			if (point1 >= 0 && point2 >= 0) {
				// Calculate the difference between the start and move coordinates
				let diffX = touchCache[point1].clientX - ev.touches[0].clientX;
				let diffY = touchCache[point2].clientY - ev.touches[1].clientY;

				newLeft = leftCache - diffX;
				if (newLeft > 0) newLeft = 0;
				if (newLeft < viewportWidth - assistantWidth) newLeft = viewportWidth - assistantWidth;
				newTop = topCache - diffY;
				if (newTop > 0) newTop = 0;
				if (newTop < viewportHeight - assistantHeight) newTop = viewportHeight - assistantHeight;

				assistantDraggableItem.style.top = newTop + 'px';
				assistantDraggableItem.style.left = newLeft + 'px';
			} else {
				// empty touchCache
				touchCache = new Array();
			}
		}
	}

	function touchSetClasses(ev) {
		switch (ev.touches.length) {
			case 1:
				// Single tap`
				if (viewportWidth < assistantWidth) {
					assistantOverlay.classList.add('touched');
				}
				break;
			case 2:
				// Two simultaneous touches
				assistantOverlay.classList.remove('touched');
				break;
			default:
			// More than two simultaneous touches
		}
	}

	function touchstartHandler(ev) {
		// If the user makes simultaneous touches, the browser will fire a
		// separate touchstart event for each touch point. Thus if there are
		// three simultaneous touches, the first touchstart event will have
		// targetTouches length of one, the second event will have a length
		// of two, and so on.
		// Cache the touch points for later processing of 2-touch pinch/zoom
		if (ev.touches.length >= 2) {
			ev.preventDefault();
			for (let i = 0; i < ev.touches.length; i++) {
				touchCache.push(ev.touches[i]);
			}
		}
		touchSetClasses(ev);
	}

	function touchmoveHandler(ev) {
		// Note: if the user makes more than one "simultaneous" touches, most browsers
		// fire at least one touchmove event and some will fire several touchmoves.
		// Consequently, an application might want to "ignore" some touchmoves.
		if (ev.touches.length == 2 || ev.targetTouches.length == 2) ev.preventDefault();

		touchSetClasses(ev);
		touchSetPosition(ev);
	}

	function touchendHandler(ev) {
		if (ev.touches.length == 0) {
			assistantOverlay.classList.remove('touched');
			assistantOverlay.classList.remove('untouched');
			topCache = parseInt(assistantDraggableItem.style.top);
			leftCache = parseInt(assistantDraggableItem.style.left);
		}
	}

	function disableZoomOverlay(ev) {
		if (ev.touches.length == 2 || ev.targetTouches.length == 2) ev.preventDefault();
	}

	// mouse events -----------------------------------------

	function mousedownHandler(ev) {
		ev.preventDefault();
		moveCache = ev;
	}

	function mousemoveHandler(ev) {
		if (moveCache) {
			let diffX = moveCache.clientX - ev.clientX;
			let diffY = moveCache.clientY - ev.clientY;

			newLeft = leftCache - diffX;
			if (newLeft > 0) newLeft = 0;
			if (newLeft < viewportWidth - assistantWidth) newLeft = viewportWidth - assistantWidth;
			newTop = topCache - diffY;
			if (newTop > 0) newTop = 0;
			if (newTop < viewportHeight - assistantHeight) newTop = viewportHeight - assistantHeight;

			assistantDraggableItem.style.top = newTop + 'px';
			assistantDraggableItem.style.left = newLeft + 'px';
		}
	}

	function mouseupHandler(ev) {
		moveCache = null;
		topCache = parseInt(assistantDraggableItem.style.top);
		leftCache = parseInt(assistantDraggableItem.style.left);
	}

	// tooltips ---------------------------------------------

	function mouseOverTooltipHandler(ev) {
		ev.currentTarget.classList.add('assistant-3d__tooltip--open');
	}

	function mouseOutTooltipHandler(ev) {
		ev.currentTarget.classList.remove('assistant-3d__tooltip--open');
	}

	function toggleTooltipHandler(ev) {
		if (ev.target.tagName.toLowerCase() !== 'a') {
			Array.from(assistantTooltips).forEach((tooltip) => {
				tooltip.classList.remove('assistant-3d__tooltip--open');
			});
			ev.currentTarget.classList.add('assistant-3d__tooltip--open');
		}
	}

	function initTooltipLink(ev) {
		if (this.hash !== '') {
			ev.preventDefault();
			let hash = this.hash;
			let $tableItem = $(hash);
			$('html, body')
				.animate(
					{
						scrollTop: $tableItem.offset().top,
					},
					400,
				)
				.promise()
				.then(function () {
					if (MQ('mdDown')) {
						$tableItem.addClass('open').find('.assistant-3d__table__detail').slideDown(300);
					}
					history.replaceState(null, '', hash);
				});
		}
	}

	function toggleTableItemHandler(ev) {
		$(this).closest('.assistant-3d__table__item').toggleClass('open').find('.assistant-3d__table__detail').slideToggle(300);
	}

	// init --------------------------------------------

	function initAssistant3d() {
		if ($('html').hasClass('no-hoverevents')) {
			//		if (isTouchDevice()) {
			// init touch events
			assistantDraggableItem.addEventListener('touchstart', touchstartHandler);
			assistantDraggableItem.addEventListener('touchmove', touchmoveHandler);
			// Use same handler for touchcancel and touchend
			assistant.addEventListener('touchcancel', touchendHandler);
			assistant.addEventListener('touchend', touchendHandler);

			// disable zoom on overlay element
			assistantOverlay.addEventListener('touchmove', disableZoomOverlay);

			// set overlay on load
			assistantOverlay.classList.add('untouched');
		} else {
			if (viewportWidth < assistantWidth) {
				// init mouse events
				assistantDraggableItem.addEventListener('mousedown', mousedownHandler);
				window.addEventListener('mousemove', mousemoveHandler);
				window.addEventListener('mouseup', mouseupHandler);

				// set move cursor
				assistantDraggableItem.classList.add('non-touched');
			}
		}

		// init tooltips
		if ($('html').hasClass('no-hoverevents')) {
			//		if (isTouchDevice()) {
			assistantTooltips[0].classList.add('assistant-3d__tooltip--open');
			Array.from(assistantTooltips).forEach((tooltip) => {
				tooltip.addEventListener('click', toggleTooltipHandler);
				tooltip.querySelector('a').addEventListener('click', initTooltipLink);
			});
		} else {
			Array.from(assistantTooltips).forEach((tooltip) => {
				tooltip.addEventListener('mouseover', mouseOverTooltipHandler);
				tooltip.addEventListener('mouseout', mouseOutTooltipHandler);
				tooltip.querySelector('a').addEventListener('click', initTooltipLink);
			});
		}

		// init toggled item in table for mobile devices
		if (MQ('mdDown')) {
			[...toggledTableItems].forEach((tableItem) => {
				tableItem.addEventListener('click', toggleTableItemHandler);
			});
		}

		// set image position
		leftCache = 0;
		// set offset image on small screen
		if (viewportWidth < assistantWidth && mobileBgOffset !== 0) {
			leftCache = -(assistantDraggableItem.clientWidth / (100 / mobileBgOffset) - window.innerWidth / (100 / mobileBgOffset));
		}
		assistantDraggableItem.style.top = '0px';
		assistantDraggableItem.style.left = leftCache + 'px';
	}

	initAssistant3d();

	$(window).on('orientationchange', function () {
		// After orientationchange, add a one-time resize event
		$(window).one('resize', function () {
			leftCache = 0;
			if (viewportWidth < assistantWidth && mobileBgOffset !== 0) {
				leftCache = -(assistantDraggableItem.clientWidth / (100 / mobileBgOffset) - window.innerWidth / (100 / mobileBgOffset));
			}
			assistantDraggableItem.style.top = '0px';
			assistantDraggableItem.style.left = leftCache + 'px';
		});
	});
};
